import { RECIPIENTS_NONE } from 'Pages/EmailSendingWizard/const'
import { atom, selector } from 'recoil'

export const pageState = atom({
  key: 'SendingWizardPageState',
  default: {
    loaded: false,
    loading: false,

    error: false,
    wizardStep: 1,
    severity: 'danger',
    totalSend: 0,
    totalQueued: 0,
    sendLimit: 0,
    trialRecipientLimit: 0,
    remainingSendings: 0,
    wizardStep1Done: false,
    showSegmentationMessage: false,
    recipients: RECIPIENTS_NONE,
    idTestDefault: undefined,
    dynamicOptions: [],
    idMessage: undefined,
    goToWizardStep3: false
  }
})

export const wizardEnableStep1State = selector({
  key: 'SendingWizardEnableStep1State',
  get: ({ get }) => {
    const { wizardStep } = get(pageState)

    return wizardStep !== 3
  }
})

export const wizardEnableStep2State = selector({
  key: 'SendingWizardEnableStep2State',
  get: ({ get }) => {
    const { wizardStep, wizardStep1Done } = get(pageState)

    return wizardStep === 2 || (wizardStep === 1 && wizardStep1Done)
  }
})

export const wizardEnableStep3State = selector({
  key: 'SendingWizardEnableStep3State',
  get: ({ get }) => {
    const { wizardStep } = get(pageState)

    return wizardStep === 3
  }
})

export const abitudiniApertureState = atom({
  key: 'emailSendingWizardAbitudiniApertureState',
  default: {
    avaible: true,
    toCalculate: true,
    loading: false,
    bestValue: ''
  }
})

export const smartPlanningState = atom({
  key: 'emailSendingWizardSmartPlanningState',
  default: {
    smartPlanningDate: null,
    smartPlanningDateLoaded: false,
    smartPlanningError: undefined
  }
})
